// Date helpers that treat YYYY-MM-DD strings as LOCAL dates.
// Avoids the UTC off-by-one bug where new Date('2026-06-15') renders as June 14
// in timezones behind UTC, and where toISOString() pre-fills tomorrow's date in the evening.

// Convert a Date object to a local YYYY-MM-DD string
export const toLocalDateString = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

// Today's date as a local YYYY-MM-DD string (for date input defaults)
export const todayLocal = () => toLocalDateString(new Date());

// Parse a value into a Date, treating bare YYYY-MM-DD strings as local midnight
export const parseLocalDate = (value) => {
  if (value instanceof Date) return value;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(`${value}T00:00:00`);
  }
  return new Date(value);
};

// Drop-in replacement for `new Date(x).toLocaleDateString(...)` that is timezone-safe
export const formatLocalDate = (value, localeOrOptions, maybeOptions) => {
  if (!value) return '';
  const d = parseLocalDate(value);
  if (isNaN(d.getTime())) return '';
  if (typeof localeOrOptions === 'string') {
    return d.toLocaleDateString(localeOrOptions, maybeOptions);
  }
  return d.toLocaleDateString(undefined, localeOrOptions);
};
